import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import { Box } from '@mui/material';
import InfoCard from '../InfoCard';

const pageDescriptions = [
  {
    title: "About Us",
    description: "Learn about SJ Swimming's mission, values, and commitment to helping swimmers of all levels grow in confidence and skill.",
    image: "/images/SJ_Gallery/LTS_1.jpg", 
    link: "/about-us",
  },
  {
    title: "Our Locations",
    description: "Find a convenient pool location near you and explore the facilities we offer for swimmers of all ages.",
    image: "/images/SJ_Gallery/Knox_Pool.jpg", 
    link: "/locations",
  },
  {
    title: "Programs",
    description: "Discover our tailored swim programs, from beginner lessons to advanced training, designed to suit every swimmer’s journey.",
    image: "/images/SJ_Gallery/SQ_Su_8.jpg", 
    link: "/programs",
  },
  {
    title: "Contact Us",
    description: "Have questions or want to enroll? Reach out to our friendly team we're here to help!",
    image: "/images/SJ_Gallery/LTS_3_1.jpg",
    link: "/contact-us",
  },
];


function Home() {
  return (
    
    <div className="home-container">

      <HeroSection />
      
      <Box sx={{ mt: 6, mb: 6 }}>
        {pageDescriptions.map((page, index) => (
          <InfoCard 
            key={index}
            title={page.title}
            description={page.description}
            image={page.image}
            link={page.link}
            reverse={index % 2 !== 0} // Alternate left-right
          />
        ))}
      </Box>
    </div>
  );
}

export default Home;
